<template>
  <div class="applet-view">
    <water-view :items="state.items"></water-view>
  </div>
</template>
<script setup>
import WaterView from '@/components/WaterView.vue';
import img01 from '@/assets/images/other/xcx-case01.png';
import img02 from '@/assets/images/other/xcx-case02.png';
import img04 from '@/assets/images/other/xcx-case04.png';
import img05 from '@/assets/images/other/xcx-case05.png';
import img06 from '@/assets/images/other/xcx-case06.png';
import img07 from '@/assets/images/other/xcx-case07.png';
import img08 from '@/assets/images/other/xcx-case08.png';
import img09 from '@/assets/images/other/xcx-case09.png';
import img10 from '@/assets/images/other/xcx-case10.png';
import img11 from '@/assets/images/other/xcx-case11.png';
import img12 from '@/assets/images/other/xcx-case12.png';
import img13 from '@/assets/images/other/xcx-case13.png';
import { reactive } from 'vue-demi';
const state = reactive({
  items: [
    {
      key: 'xx11',
      img: img11
    },
    {
      key: 'xx12',
      img: img12
    },

    {
      key: 'xx13',
      img: img13
    },
    {
      key: 'xx',
      img: img01
    },
    {
      key: 'xx2',
      img: img02
    },
    {
      key: 'xx4',
      img: img04
    },
    {
      key: 'xx05',
      img: img05
    },
    {
      key: 'xx06',
      img: img06
    },
    {
      key: 'xx07',
      img: img07
    },
    {
      key: 'xx08',
      img: img08
    },

    // {
    //   key: 'xx09',
    //   img: img09
    // },
    {
      key: 'xx10',
      img: img10
    },


  ]
})
</script>
<style lang="less" >
.applet-view {
  min-height: 3200px;
}
</style>